import { NgModule } from '@angular/core'
import { ResetPasswordComponent } from './reset-password.component'
import { ResetPasswordRoutingModule } from './reset-password-routing.module'
import { SharedModule } from '../shared/shared.module'
import { FormErrorsModule } from '../shared/form-errors/form-errors.module'

@NgModule({
  imports: [ResetPasswordRoutingModule, SharedModule, FormErrorsModule],
  exports: [ResetPasswordComponent],
  declarations: [ResetPasswordComponent]
})
export class ResetPasswordModule {}
